var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlideshow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 16.5037L21.25 16.5037C21.9404 16.5037 22.5 15.944 22.5 15.2537L22.5 2.75C22.5 2.05964 21.9404 1.5 21.25 1.5L2.75 1.5C2.05964 1.5 1.5 2.05965 1.5 2.75L1.5 15.2537C1.5 15.944 2.05964 16.5037 2.75 16.5037ZM21.25 18.0037L13.0639 18.0037L17.7803 22.7196C18.0732 23.0125 18.0732 23.4874 17.7804 23.7803C17.4875 24.0732 17.0126 24.0732 16.7197 23.7804L11.9996 19.0607L7.28035 23.7803C6.98748 24.0732 6.5126 24.0732 6.2197 23.7804C5.92679 23.4875 5.92677 23.0126 6.21965 22.7197L10.9352 18.0037L2.75 18.0037C1.23122 18.0037 0 16.7724 0 15.2537V2.75C0 1.23122 1.23122 1.19409e-06 2.75 1.19409e-06L21.25 -1.90735e-06C22.7688 -1.77457e-06 24 1.23121 24 2.75V15.2537C24 16.7724 22.7688 18.0037 21.25 18.0037ZM10.1859 4.6397C9.95732 4.47641 9.65662 4.45458 9.40681 4.58313C9.15701 4.71168 9 4.96906 9 5.25V12.75C9 13.0309 9.15701 13.2883 9.40681 13.4169C9.65662 13.5454 9.95732 13.5236 10.1859 13.3603L15.4359 9.6103C15.633 9.46952 15.75 9.24222 15.75 9C15.75 8.75779 15.633 8.53049 15.4359 8.3897L10.1859 4.6397ZM10.5 11.2926V6.7074L13.7097 9L10.5 11.2926Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlideshow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slideshow.f5c400afb5b2b3bfdcab729e4b4a9b51.svg";